var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSqCheck(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17.0 17.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375,0 L375,812 L0,812 L0,0 L375,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13,0 C14.1045695,-2.02906125e-16 15,0.8954305 15,2 L15,13 C15,14.1045695 14.1045695,15 13,15 L2,15 C0.8954305,15 1.3527075e-16,14.1045695 0,13 L0,2 C-1.3527075e-16,0.8954305 0.8954305,2.02906125e-16 2,0 L13,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.96923077,0.12 L10.5435897,0.68 C10.6871795,0.82 10.7051282,1.02125 10.5974359,1.1765625 L10.5435897,1.24 L3.97948718,7.88 C3.8974359,7.96 3.81538462,8 3.69230769,8 C3.56923077,8 3.48717949,7.96 3.40512821,7.88 L0.205128205,4.52 L0.123076923,4.4 C0.041025641,4.32 0,4.2 0,4.12 C0,4.04 0.041025641,3.92 0.123076923,3.84 L0.697435897,3.28 C0.861538462,3.12 1.10769231,3.12 1.27179487,3.28 L1.31282051,3.32 L3.56923077,5.68 C3.65128205,5.76 3.77435897,5.76 3.85641026,5.68 L9.35384615,0.12 L9.39487179,0.12 C9.55897436,-0.04 9.80512821,-0.04 9.96923077,0.12 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-343.0 -269.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0 20.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.0 204.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.0 28.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(314.0 18.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 15,0 15,15 0,15 0,0",
    stroke: "none",
    fill: "#7BCB44"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2,0 L13,0 C14.1045695,-2.02906125e-16 15,0.8954305 15,2 L15,13 C15,14.1045695 14.1045695,15 13,15 L2,15 C0.8954305,15 1.3527075e-16,14.1045695 0,13 L0,2 C-1.3527075e-16,0.8954305 0.8954305,2.02906125e-16 2,0 Z",
    stroke: "#7BCB44",
    strokeWidth: 1,
    fill: "none",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.9999999999999227 4.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i2)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,-1.38777878e-17 10.6666667,-1.38777878e-17 10.6666667,8 0,8 0,-1.38777878e-17",
    stroke: "none",
    fill: "#FFFFFF"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSqCheck);
export default __webpack_public_path__ + "static/media/icSqCheck.918ff45dd8f59616028215161d6e4167.svg";
export { ForwardRef as ReactComponent };